import { Component, Inject, input, OnInit, signal, ViewEncapsulation } from '@angular/core';

import { ImageLocation } from 'extensions/core/piece-product-carousel/front/models/piece-product-carousel.model';
import { ProductsHelpers } from 'idt-ecommerce-api/catalog/products/products.helpers';
import { Product, ProductSize } from 'idt-ecommerce-api/catalog/products/products.models';
import { RenderSetupDataService } from 'idt-ecommerce-api/render-setup-data/render-setup-data.service';
import { LazyDataInterface } from 'shared/lazy-load/lazy-load.interface';
import { InditexWindow } from 'shared/models/inditex-window.models';


interface AddToCartProps {
  data: {
    product: Product;
    size: ProductSize | string;
  };
}

@Component({
  selector: 'render-add-to-cart-modal',
  templateUrl: 'render-add-to-cart-modal.component.html',
  styleUrls: ['./render-add-to-cart-modal.component.scss'],
  encapsulation: ViewEncapsulation.ShadowDom
})
export class RenderAddToCartModalComponent implements OnInit {

  public readonly props = input.required<AddToCartProps>();

  public readonly addedToCartMessage = signal<string>('');

  constructor(
    @Inject('Window') private readonly window: InditexWindow,
    private readonly renderSetupDataService: RenderSetupDataService
  ) { }

  public ngOnInit(): void {
    const translations = this.renderSetupDataService.translations;
    const sizeData = this.props().data.size;
    const size = typeof sizeData === 'string' ? JSON.parse(sizeData)?.name : sizeData.name;
    const addToCartTemplate = translations?.['product-card.size-add-to-cart-success'];
    const message = typeof addToCartTemplate === 'string'
      ? addToCartTemplate.replace(/\{(\d+)\}/g, (match: string, index: string) => {
          const values = [size];
          const replacement = values[Number(index)];
          return replacement ?? match;
        })
      : this.window.inditex?.text?.('ItxProductPage.sizeAdded', size);
    this.addedToCartMessage.set(message || '');
  }

  public getProductImageData(): LazyDataInterface | undefined {
    const width = 48;
    const location: ImageLocation = 'category_page';

    const imageView = ['s1', 's', 'c1', 'c'];

    const media = ProductsHelpers.firstImageForFirstColor(
      this.props().data.product.colors, location, width, undefined, undefined, imageView
    );

    const src = media?.url ? media.url : media?.extraInfo?.deliveryUrl || '';
    const productImageData: LazyDataInterface = { src, width: media?.size?.width, height: media?.size?.height };

    return productImageData;
  }

}
